import api from '../../api/axios';

export const getTexts = async (payload) => {
  try {
    const { data } = await api.post(`/api/texts/search`, payload);
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};

export const getSelectedTexts = async (set, patientID, setId) => {
  try {
    const { data } = await api.get(
      `/api/patients/${patientID}/${set}/${setId}`,
    );
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};
